import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Select from "react-select";

// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  CircularProgress
} from "@mui/material";
// components
import "react-toastify/dist/ReactToastify.css";
import { notification } from "src/utils/messages";
import { GreetingDelete, insertPrimeGreeting, ResendPrimeGreeting } from "src/api/commonapi";
import Page from "../components/Page";
import { fetchGreetingList } from "src/utils/common";
import { DeleteSharp, NotificationsActive } from "@mui/icons-material";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import CustomLoader from "src/components/CustomLoader";

export default function Greeting() {
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const [gettabledata, settabledata] = useState([]);
  const [newGetTableData, setNewTableData] = useState([]);
  const [response, setresponse] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const [getdata, setgetdata] = useState({
    g_type: 4, // 0 - LVB , 1- State, 2- City, 3- Chapter, 4- Prime
    g_type_id: 0,
    g_title: "",
    g_description: ""
  });

  const getlandmarklist = async () => {
    setIsLoading(true);
    settabledata(await fetchGreetingList());
    setIsLoading(false);
  };
  const onChangeFunction = (e) => {
    setgetdata({
      ...getdata,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    let fdata = new FormData();
    fdata.append("g_type", getdata?.g_type);
    fdata.append("g_type_id", getdata?.g_type_id);
    fdata.append("g_title", getdata?.g_title);
    fdata.append("g_description", getdata?.g_description);

    if (step == 1) {
      if (
        getdata.g_title == "" ||
        getdata.g_title == undefined ||
        getdata.g_description == "" ||
        getdata.g_description == undefined
      ) {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields"
        });
        notify();
      } else {
        setIsLoading(true);
        const resp = await insertPrimeGreeting(fdata);
        setIsLoading(false);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        setgetdata({
          g_type: 4, // 0 - LVB , 1- State, 2- City, 3- Chapter, 4- Prime
          g_type_id: 0,
          g_title: "",
          g_description: ""
        });

        setStep(0);
        getlandmarklist();
      }
    }
  };

  useEffect(async () => {
    setIsLoading(true);
    settabledata(await fetchGreetingList());
    setIsLoading(false);
  }, [response]);

  const greetingDelete = async (g_id) => {
    const resp = await GreetingDelete(g_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const resendGreetingNotification = async (g_id) => {
    const resp = await ResendPrimeGreeting(g_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setresponse(response + 1);
    }
  };

  const expo_columns = [
    { label: "No", key: "g_id" },
    { label: "Title", key: "g_title" },
    { label: "Description", key: "g_description" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true
    },

    {
      name: "Title",
      wrap: true,
      selector: (row) => row.g_title,
      sortable: true
    },
    {
      name: "Description",
      wrap: true,
      selector: (row) => row.g_description,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <>
          <a
            onClick={() => {
              setDvisible({ mval: true, id: row.g_id });
            }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </a>
          <a onClick={() => resendGreetingNotification(row.g_id)}>
            <Tooltip title="Send">
              <IconButton>
                <NotificationsActive color="warning" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ];

  const [filterData, setFilterData] = useState({
    search: ""
  });

  const handleFilterData = () => {
    const newGreetingData = gettabledata?.filter((greeting) => filterBySearch(greeting));

    setNewTableData(newGreetingData);
  };

  const filterBySearch = (greeting) => {
    let searchFilterText = filterData.search.toLowerCase();

    return (
      filterData.search == "" ||
      greeting?.g_title?.toLowerCase()?.includes(searchFilterText) ||
      greeting?.g_description?.toLowerCase()?.includes(searchFilterText)
    );
  };

  useEffect(() => {
    handleFilterData();
  }, [gettabledata, filterData]);

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={greetingDelete} />

      <Page title="Greeting | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Greeting
            </Typography>
          </Stack>
          {/* Start Category Form */}
          {step != 0 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setgetdata({
                    g_type: 4, // 0 - LVB , 1- State, 2- City, 3- Chapter, 4- Prime
                    g_type_id: 0,
                    g_title: "",
                    g_description: ""
                  });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card
                style={{
                  padding: "25px",
                  paddingBottom: "25px",
                  marginBottom: "25px"
                }}
              >
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={getdata?.g_title ? getdata?.g_title : ""}
                    type="text"
                    label="Name"
                    name="g_title"
                    onChange={onChangeFunction}
                  />
                </Stack>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    type="text"
                    value={getdata?.g_description ? getdata?.g_description : ""}
                    label="Description"
                    name="g_description"
                    onChange={onChangeFunction}
                  />
                </Stack>
                <Button
                  style={{ marginTop: "15px" }}
                  onClick={handleSubmit}
                  variant="contained"
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  submit
                </Button>
              </Card>
            </>
          ) : (
            <>
              <Button
                onClick={() => {
                  setStep(1);
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Add New Greeting
              </Button>
              <Card className="p-20">
                <Grid container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid item xs={7}>
                    <Stack spacing={10}>
                      <TextField
                        style={{ marginTop: "0px" }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        label="Search"
                        name="name"
                        autoCorrect="off"
                        value={filterData.search}
                        onChange={(e) => {
                          setFilterData({
                            ...filterData,
                            search: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end"
                    }}
                  >
                    <Button
                      onClick={async () => {
                        setFilterData({
                          search: ""
                        });
                      }}
                      variant="contained"
                    >
                      clear
                    </Button>
                  </Grid>
                </Grid>
              </Card>
              <Card className="p-20" sx={{ mt: 2 }}>
                {gettabledata && (
                  <>
                    <Button className="btn btn-export">
                      <CSVLink
                        data={gettabledata}
                        headers={expo_columns}
                        filename={"GreetingList.csv"}
                        className="btn btn-primary test"
                        target="_blank"
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                    <DataTable
                      filter
                      pagination
                      highlightOnHover
                      columns={columns}
                      data={newGetTableData != null && newGetTableData}
                      progressPending={isLoading}
                      progressComponent={<CustomLoader />}
                    />
                  </>
                )}
              </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
